import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// molecule — DWR sheet row: riga label uppercase + value generica.
// Riusato dentro <SheetSection> per Identità, Aspetti, Equipaggiamento ecc.
// Pattern .sheet-row mockup (styles.css righe 1797-1811): grid 140px label + 1fr value.

interface SheetRowProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export function SheetRow({ label, children, className }: SheetRowProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-[140px_1fr] items-baseline gap-[0.6rem] text-[0.95rem]',
        className,
      )}
    >
      <span className="font-display text-ink-soft text-xs tracking-[0.08em] uppercase">
        {label}
      </span>
      <span className="font-serif">{children}</span>
    </div>
  );
}
